<template>
    <div v-if="item">
      <div class="row border-bottom mb-4">
        <div class="col-12">
          <h5 class="patient-card__representative-title">Данные ребенка</h5>
              <div class="row d-flex flex-wrap flex-column flex-sm-row">
                <div class="form-group col-3">
                  <label class="control-label">ФИО</label>
                </div>
                <div class="form-group col-9 patient-card__item-data">
                  {{ item.surname }} {{ item.name }} {{ item.patronimic }}
                </div>
                <div class="form-group col-3">
                  <label class="control-label">Дата рождения</label>
                </div>
                <div class="form-group col-9 patient-card__item-data">
                  {{ $momentFormat(item.dateOfBirth, "DD.MM.YYYY") }}
                </div>
                <div class="form-group col-3" v-if="item.addressDistrictName">
                  <label class="control-label">Район</label>
                </div>
                <div class="form-group col-9 patient-card__item-data"  v-if="item.addressDistrictName">
                  {{ item.addressDistrictName }}
                </div>
                <div class="form-group col-3" v-if="item.address">
                  <label class="control-label">Адрес</label>
                </div>
                <div class="form-group col-9 patient-card__item-data" v-if="item.address">
                  {{ item.address }}
                </div>
                <template v-if="item.medOrgName || !item.createdById">
                <div class="form-group col-3 block_medorg">
                  <label class="control-label">МО прикрепления</label>
                </div>
                <div class="form-group col-9 patient-card__item-data">
                  <span>{{ item.medOrgName || "(Не заполнено)" }}</span>
                  <button-component
                      v-if="!item.createdById"
                      class="justify-content-center btn-qr-code ml-4"
                      @click="updateFromRMIS" :disabled="isUpdateFromRMIS"
                  ><i class="fa fa-spinner fa-spin mr-2" v-if="isUpdateFromRMIS"> </i>Обновить данные из ЕЦП
                  </button-component>
                </div>
                </template>
              </div>
        </div>
        <div class="col-12">
          <h5 class="patient-card__representative-title">Законный представитель</h5>

              <div v-for="(repres) in item.tmpRepresentatives" :key="repres.id" class="row d-flex flex-wrap flex-column flex-sm-row">
                  <div class="form-group col-3">
                    <label class="control-label">ФИО</label>
                  </div>
                  <div class="form-group col-9 patient-card__item-data">
                    {{ repres.surname }} {{ repres.name }} {{ repres.patronimic }}
                  </div>
                  <div class="form-group col-3">
                    <label class="control-label">Степень родства</label>
                  </div>
                  <div class="form-group col-9 patient-card__item-data">
                    {{ repres.relationType?.name }}
                  </div>
                  <div class="form-group col-3">
                    <label class="control-label">Контактный телефон</label>
                  </div>
                  <div class="form-group col-9 patient-card__item-data">
                    {{ repres.phone }}
                  </div>
                </div>
        </div>
      </div>

            <div class="border-bottom mb-4">
              <h5 class="patient-card__representative-title">Данные анкеты</h5>
                <div class="row">
                  <div class="form-group col-3">
                    <label class="control-label">Дата заполнения</label>
                  </div>
                  <div class="form-group col-9 patient-card__item-data">
                    {{ $momentFormat(item.pollCompleted?.dateStart, "DD.MM.YYYY HH:mm") }}
                  </div>
                  <div class="form-group col-3">
                    <label class="control-label">Продолжительность тестирования</label>
                  </div>
                  <div class="form-group col-9 patient-card__item-data">
                    {{ item.pollCompleted?.duration ? item.pollCompleted.duration : item.duration }}
                  </div>
                  <div class="form-group col-3">
                    <label class="control-label">Количество баллов</label>
                  </div>
                  <div class="form-group col-9 patient-card__item-data">
                    {{ item.pollCompleted?.numberOfPoints }}
                  </div>
                  <div class="form-group col-3">
                    <label class="control-label">Степень риска</label>
                  </div>
                  <div class="form-group col-9 patient-card__item-data">
                    {{ item.riskName }}
                  </div>
                  <div class="form-group col-3" v-if="!item.createdById || item.anketaFileId">
                    <label class="control-label">Анкета</label>
                  </div>
                  <div class="form-group col-9 patient-card__item-data" v-if="!item.createdById || item.anketaFileId">
                    <a @click="downloadAnketa">Скачать</a>
                  </div>
                </div>
            
            </div>

              <div class="row">
                  <div class="form-group col-3">
                    <label class="control-label">Статус</label>
                  </div>
                  <div class="form-group col-9 patient-card__item-data">
                    {{ item.statusName }}
                  </div>
                  <div class="form-group col-3">
                    <label class="control-label">Дата приема врача</label>
                  </div>
                  <div class="form-group col-9 patient-card__item-data">
                    {{ $momentFormat(item.dateVisitDoctor, "DD.MM.YYYY HH:mm") }}
                  </div>
                  <div class="form-group col-3">
                    <label class="control-label">Комментарий</label>
                  </div>
                  <div class="form-group col-9 patient-card__item-data">
                    {{ item.statusComment }}
                  </div>

                <div class="form-group">
                  <div class="form-check my-1">
                    <component-input
                      label="Согласие на обработку персональных данных"
                      v-model="item.agreePersonalData"
                      id="chAgreePersonalData"
                      type="checkbox"
                      scopeName="general"
                      disabled
                    />
                  </div>
                  <div class="form-check my-1">
                    <component-input
                      label="Согласие на внесение в Регистр ЛРАС"
                      v-model="item.agree"
                      id="chAgree"
                      type="checkbox"
                      scopeName="general"
                      disabled
                    />
                  </div>
                </div>
              
            </div>


            <div>
              <div class="float-right d-flex">
                <button-component kind="secondary" type="button" class="btn btn-default" v-on:click="close">Закрыть</button-component>
              </div>
             </div>

    </div>
</template>
<script>
import Api from '../api/poll'
import Constants from '@/common/constants'
//import DateComponent from "@/common/components/DateComponent"
import ButtonComponent from "@/common/ui/ButtonComponent";
//import ComponentInput from "@/common/components/ComponentInput";
import security from "@/common/mixins/security";
//import Utils from "@/common/utils";
//import FileUpload from "@/common/components/FileUpload";
import FileAPI from "@/modules/file/api";
import ComponentInput from "@/common/components/ComponentInput";

export default {
  name: "TmpPatientView",
  props: {
    id: {
        type: Number
    }
  },
  components: {
      ButtonComponent,
      ComponentInput
  },
  mixins: [security],
  created() {
    this.checkPermission(Constants.TmpPatientView).then((response) => { 
        if(response.data)
            this.loadCard();
        else
            Constants.alert.fire('Ошибка', 'Недостаточно прав', 'error' );
    });
  },
  data() {
    return {
        item: null,
        isUpdateFromRMIS: false
    };
  },
  methods: {
    loadCard() {
        Api.find(this.id)
          .then((response) => {
            this.item = response.data;
          });
      },
    close() {
      this.$emit('close');
    },
    downloadAnketa() {
        if(this.item.createdById) {
            this.download(this.item.anketaFileId, this.item.anketaFile);
        } else {
            Api.exportFile(this.item.uid);
        }
    },
    downloadFile() {
        this.download(this.item.fileId, this.item.file);
    },
    download(id, file) {
        if(id) {
            FileAPI.download(id)
          .then(response => {
              const blob = new Blob([response.data], { type: file.fileType });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.target = '_blank';
                link.download = file.originalName;
                link.click();
                URL.revokeObjectURL(link.href);
          });
        }
    },
    updateFromRMIS() {
      this.isUpdateFromRMIS = true;
      Api.updatePatientMedOrgAttach(this.id).then((response) => {
        if (response.data.success) {
          Constants.alert.fire("Обновление", "Данные успешно обновлены.", "success");
          this.loadCard();
        } else {
          Constants.alert.fire("Обновление", response.data.message, "error");
        }
      })
      .finally(() => {
        this.isUpdateFromRMIS = false;
      });
    }
  }
}; 
</script>
<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.block_medorg {
  padding-top: 14px;
}

.form-group.required .control-label:after { 
   content:"*";
   color:red;
}
.form-check.required .control-label:after { 
   content:"*";
   color:red;
}
.invalid-msg {
  color:red;
  font-size: 0.75rem;
}
.control-label{
    font-weight: 400 !important;
    color: $gray-dark;
    font-size: 16px;
}

.patient-card {

  .form-group {
    margin-bottom: 0.25rem;
  }

  &__title {
    flex: 1;
    font-size: 24px;
    line-height: 28.8px;
  }
  &__curator {
    text-align: right;
  }
  &__curator-fio {
    font-size: 16px;
    line-height: 19.2px;
    font-weight: 700;
  }
  &__cross {
    align-self: flex-start;
    cursor: pointer;
  }
  &__item-data {
    font-size: 16px;
    font-weight: 700;

    a {
      cursor: pointer;
      color: #438EF0 !important;
    }
  }
  &__representatives {
    padding-top: 32px;
  }
  &__representative-title {
    font-size: 16px;
    line-height: 19.2px;
    font-weight: 600;
    margin-bottom: 22px;
  }
}

@media (max-width: 1440px) {
  .block_medorg {
    padding-top: 8px;
  }
}

</style>
